export default {
  nome: {
    value: null,
    maxlength: '200',
    required: true,
    state: null
  },
  gedPastaPaiID: {
    value: null,
    required: false,
    state: null
  },
  gedAssuntoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gedTipoID: {
    value: null,
    options: [],
    requied: false,
    state: null
  },
  gedChecklistID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gedPastaTags: {
    value: [],
    required: false,
    state: null
  },
  gedTagID: {
    value: null,
    options: []
  },
  seguranca: {
    value: false,
    options: [],
    required: true,
    state: null
  },
  propagar: {
    value: false
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/folder/addfolder-form.js